import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSunOutlined = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-.5 -.5 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Sun Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path
      stroke="currentColor"
      d="M3.3977 7.5c0 3.158 3.4186 5.1317 6.1535 3.5527A4.102 4.102 0 0 0 11.6023 7.5c0-3.158-3.4185-5.1317-6.1535-3.5527A4.102 4.102 0 0 0 3.3977 7.5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M7.5.6628v.6837M7.5 13.6535v.6837M14.3372 7.5h-.6837M1.3465 7.5H.6628M12.3344 2.6656l-.2685.2685M2.934 12.066l-.2686.2686M12.3344 12.3344l-.2685-.2685M2.934 2.934l-.2686-.2686"
    />
  </svg>
);
export default SvgSunOutlined;
